import { useState } from "react";
import { useApp } from "../context";
import { receiptSample } from "../lib/engine";

export default function ImportReceipts() {
  const { actions, closeModal, notify } = useApp();
  const [text, setText] = useState(receiptSample());

  const onFile = async e => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 2000000) return notify("Maximum demo file size: 2 MB.");
    setText(await file.text());
  };

  return (
    <>
      <h2>Import bank receipts</h2>
      <p className="muted">The sample settles the remaining ₹30,000 on LC-1002. Use Finance checker to import.</p>
      <label>Upload CSV
        <input data-testid="csv-file-input" type="file" accept=".csv,text/csv" onChange={onFile} />
      </label>
      <form data-testid="receipt-form" onSubmit={e => { e.preventDefault(); actions.importReceipts(text); }}>
        <label style={{ marginTop: 15 }}>Or paste CSV
          <textarea data-testid="csv-textarea" rows={7} required value={text} onChange={e => setText(e.target.value)} />
        </label>
        <p className="muted">Simple unquoted CSV only. No embedded commas. All rows must validate before posting.</p>
        <div className="footer">
          <button type="button" data-testid="import-cancel-btn" onClick={closeModal}>Cancel</button>
          <button type="submit" className="primary" data-testid="import-submit-btn">Validate and import</button>
        </div>
      </form>
    </>
  );
}
